export class TitlesService {
  constructor ($rootScope, $translate) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$translate = $translate;
  }

  setTitle(content, description, image) {
    this.$rootScope.page.title = this.$translate.instant(content);
    this.$rootScope.page.description = this.$translate.instant(description);
    this.$rootScope.page.image = image;
  }
}
